import React from 'react';

import { IconArrowRight } from './icons';
import { MarqueeArrowsDirection } from './types';

import { StyledArrow, StyledMarqueeArrows } from './styles';

export interface MarqueeArrowsProps {
    direction?: MarqueeArrowsDirection;
    // We may want to consider passing a `count` prop,
    // which would allow more / less arrows.
}

function Arrow() {
    return (
        <StyledArrow>
            <IconArrowRight />
        </StyledArrow>
    );
}

export function MarqueeArrows({ direction = MarqueeArrowsDirection.Right }: MarqueeArrowsProps) {
    return (
        <StyledMarqueeArrows $direction={direction}>
            <Arrow />
            <Arrow />
            <Arrow />
        </StyledMarqueeArrows>
    );
}
